import React, { useContext } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { AuthContext } from './AuthContext';

const PrivateRoute = () => {
  const { isAuthenticated, loading } = useContext(AuthContext);

  console.log('PrivateRoute - isAuthenticated:', isAuthenticated, 'loading:', loading);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!isAuthenticated) {
    console.log('Not authenticated, redirecting to signin');
    return <Navigate to="/signup" />;
  }

  console.log('Authenticated, rendering Outlet');
  return <Outlet />;
};

export default PrivateRoute;